import {
  DatabaseFilled,
  DollarCircleFilled,
  FileExcelFilled,
  AreaChartOutlined,
  BoxPlotFilled,
} from '@ant-design/icons'
import { BigButton, Vertical, Horizontal, Texto } from '@gravitate-js/excalibrr'
import React from 'react'
export const APILinks = () => {
  return (
    <Horizontal style={{ height: '100vh' }} horizontalCenter verticalCenter>
      <Vertical verticalCenter alignItems='flex-end' className='pr-4'>
        <Texto align='center' category='h1'>
          Welcome to our API!
        </Texto>
        <Texto category='h5'>These are a few of the microservices that power our app. </Texto>
      </Vertical>
      <Vertical verticalCenter horizontalCenter>
        <BigButton
          icon={<DatabaseFilled style={{ fontSize: '3em', color: 'var(--theme-color-2)' }} />}
          label={<a href={`${window.location.origin}/service/auth/docs`}>Auth</a>}
        />
        <BigButton
          icon={<AreaChartOutlined style={{ fontSize: '3em', color: 'var(--theme-color-2)' }} />}
          label={<a href={`${window.location.origin}/service/forecast/docs`}>Forecast</a>}
        />
        <BigButton
          icon={<BoxPlotFilled style={{ fontSize: '3em', color: 'var(--theme-color-2)' }} />}
          label={<a href={`${window.location.origin}/service/ims/docs`}>IMS</a>}
        />
      </Vertical>
      <Vertical verticalCenter>
        <BigButton
          icon={<DollarCircleFilled style={{ fontSize: '3em', color: 'var(--theme-color-2)' }} />}
          label={<a href={`${window.location.origin}/service/payroll/docs`}>Payroll</a>}
        />
        <BigButton
          icon={<FileExcelFilled style={{ fontSize: '3em', color: 'var(--theme-color-2)' }} />}
          label={<a href={`${window.location.origin}/service/loader/docs`}>Loader</a>}
        />
      </Vertical>
    </Horizontal>
  )
}
